var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolviaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 40,
    viewBox: "0 0 180 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_22705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8267H19.5043V13.8854H15.0429L21.0677 24.814L26.8059 13.8854H23.5286V10.8267H37.0761V13.8854H32.3087L23.6739 30.0289H13.401L4.31743 13.8854H0V10.8267Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7866 20.9505V30.0276H63.0566V26.9213H67.2995V13.924H63.1261V10.8177H80.8458V13.924H76.4589V26.6038H81.5915C81.5915 26.6038 85.6916 27.1322 86.4284 20.9466L89.7866 20.9505Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0156 10.8267H104.52V13.9253H100.055L106.087 24.8191L111.818 13.9253H108.54V10.8267H122.089V13.9253H117.322L108.686 30.0289H98.4128L89.3331 13.9253H85.0156V10.8267Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.802 30.7733C48.802 30.7733 35.6016 31.2554 35.6016 20.3924C35.6016 9.52945 48.9177 10.0052 48.9177 10.0052H48.8406C48.8406 10.0052 62.1644 9.52945 62.1644 20.3924C62.1644 31.2554 48.964 30.7733 48.964 30.7733H48.802ZM48.6156 12.7052C48.6156 12.7052 44.5231 12.7052 44.5231 20.2214C44.5231 27.7377 48.685 27.6516 48.685 27.6516C48.685 27.6516 53.0796 28.0784 52.9279 20.1353C52.7761 12.1922 48.6156 12.7052 48.6156 12.7052Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.417 26.9496H136.882V13.9253H141.269V10.8267H123.551V13.9253H127.72V26.9496H123.478V30.0353H141.413L141.417 26.9496Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.516 24.508L153.23 26.9509H156.507V30.0571H142.924V26.9457H147.691L156.326 10.8499H166.599L175.684 26.9457H180.001V30.052H160.497V26.9457H164.962L163.657 24.5029L154.516 24.508ZM161.675 20.8116L158.926 16.0544L156.309 20.8681L156.225 21.0623H161.862L161.675 20.8116Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_22705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 20.7771,
    fill: "white",
    transform: "translate(0 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolviaLogo);
export default __webpack_public_path__ + "static/media/volvia-logo.553aefee9ce126bd5c5eaa05edea6d6d.svg";
export { ForwardRef as ReactComponent };